import { render } from "./PurchaseButton.vue?vue&type=template&id=a9e7eb12&lang=pug"
import script from "./PurchaseButton.vue?vue&type=script&lang=js"
export * from "./PurchaseButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__